export default __webpack_public_path__ + "static/3-22-0-0-1b2bab10b5acf3c4567e405520bd6e1e.jpg";